// src/App.jsx
import { ThemeProvider } from './ThemeContext';
import { Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/utils/ScrollToTop';
import './styles/main.scss';
import Navbar from './components/Navbar';

import Home from './pages/Home';
import Blog from './pages/Blog';
import Projects from './pages/Projects';
import Team from './pages/Company';

const App = () => (
  <ThemeProvider>
    <div className="app">
      <ScrollToTop />
      <Navbar />
    
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/company" element={<Team />} />
      </Routes>
    </div>
  </ThemeProvider>
);

export default App;
